import styled from "styled-components"

export const ScanMessageBox = styled.div`
  display: flex;
  gap: 6px;
  align-items: flex-start;
  padding: 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.05);
  overflow: clip;
  margin-top: 12px;
`

export const ScanMessageContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-left: 4px;
  align-items: flex-start;
`

export const ScanMessageTitle = styled.p`
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  margin: 0;
  padding-top: 3px;
  white-space: pre-line;
`

export const ScanNowLink = styled.a`
  color: var(--Schemes-Primary-Primary-Container, #4bd9de);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  text-decoration: none;
  flex-shrink: 0;
  padding-top: 8px;
`
